var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var SalesforceAutomations = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M6.25 8C6.25 6.61553 6.62389 5.26216 7.32438 4.11101C8.02487 2.95987 9.02051 2.06266 10.1854 1.53285C11.3503 1.00303 12.6321 0.86441 13.8687 1.13451C15.1053 1.4046 16.2412 2.07129 17.1328 3.05026C18.0244 4.02922 18.6315 5.2765 18.8775 6.63437C19.1235 7.99224 18.9972 9.3997 18.5147 10.6788M6.46562 6.18824C6.03494 6.02217 5.58146 5.9386 5.125 5.94118C4.03098 5.94118 2.98177 6.41838 2.20818 7.26781C1.4346 8.11724 1 9.26932 1 10.4706C1 11.6719 1.4346 12.8239 2.20818 13.6734C2.98177 14.5228 4.03098 15 5.125 15H11.5M14.6 23L15.8 17.2857L11 15L19 7L18.2 12.7143L23 14.4286L14.6 23Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
